import type { NoteFormSchema } from "shared/schema";
import type { AsyncValueCallback } from "shelving";
import { Field, Form, TextAreaField, TextField } from "shared/react";
import { NOTE_FORM_SCHEMA } from "shared/schema";
import { CreatorField } from "./CreatorField.js";

export function NoteForm({ data, onSubmit, children }: { data?: Partial<NoteFormSchema>; onSubmit: AsyncValueCallback<NoteFormSchema>; children: React.ReactNode }): React.ReactElement {
	return (
		<Form data={data} schema={NOTE_FORM_SCHEMA} onSubmit={onSubmit}>
			<Field title="Details">
				<TextField name="name" />
				<TextAreaField name="content" rows={8} />
			</Field>
			<CreatorField name="creator" />
			{children}
		</Form>
	);
}
